import Collapse from 'bootstrap/js/dist/collapse';

export function allLocationHandler() {

   let [...viewLocationBtn] = document.getElementsByClassName('viewLocationBtn')

   if(viewLocationBtn) {
      viewLocationBtn.forEach(btn => {
         btn.addEventListener('click', showLocations)
      })
   }
}


function showLocations() {
   const siteList = document.getElementById('all-sites')

   if(!siteList) {
      return
   }

   console.log(siteList)

   siteList.classList.add('active')

   const y = siteList.getBoundingClientRect().top + window.pageYOffset

   window.scrollTo({
      top: y, 
   })

   focusDestination(siteList)
}

function focusDestination(target) {
   setTimeout(() => {
      target.setAttribute('tabindex', 0)  
      target.focus()
      target.style.outline = '0'
      target.setAttribute('tabindex', -1)
   }, 1000)
}

document.addEventListener('DOMContentLoaded', () => {
   allLocationHandler();
});